import React from "react"
import { format } from 'date-fns';
import DodonesList from 'app/dodones/list/Index'
import DodoneStartButton from 'app/dodones/shared/StartButton';
import DodoneFinishButton from 'app/dodones/shared/FinishButton';
import DodoneNextLink from 'app/dodones/shared/NextLink';
import HeaderContext from 'app/HeaderContext';
import { useState, useCallback, useContext, useEffect } from "react"
import DodoneContext from 'app/dodones/Context';
import NumberPicker from 'app/inputs/NumberPicker'
import update from 'immutability-helper'

const StartedRecordableProgression = () => {
  const { dodone, updateDodone } = useContext(DodoneContext);
  const [series, setSeries] = useState(dodone.settings.lastSerie || [{ reps: 10 }, { reps: 8 }, { reps: 6 }]);

  const setSerieReps = useCallback((index, n) => {
    const updatedSeries = update(series, { [index]: { reps: { $set: n }}});
    setSeries(updatedSeries);
  })

  const up = useCallback((e, props) => {
    const index = props.index
    setSerieReps(index, series[index].reps + 1)
  })

  const down = useCallback((e, props) => {
    const index = props.index
    setSerieReps(index, Math.max(series[index].reps - 1, 0))
  })

  const addSerie = useCallback(() => {
    const updatedSeries = update(series, {
      $push: [series[series.length - 1]]
    })

    setSeries(updatedSeries)
  })

  const removeSerie = useCallback((index) => {
    const updatedSeries = update(series, {
      $splice: [[index, 1]]
    })

    setSeries(updatedSeries)
  })

  return <>
           <div className="flex-1 mb-8">
           </div>
           <div className="frow mb-8">
             <div className="flex-1 frow">
               {
                 Object.entries(series).map(([index, serie]) => {
                   return <div key={ index } className="flex-1 fcol">
                            <NumberPicker up={ up } down={ down } index={ index }>
                              <div className="text-3xl dark-gray-transparent-box">{ serie.reps }</div>
                            </NumberPicker>
                            {
                              series.length == 1 ? null :
                                <div className="btn btn-danger btn-circle" onClick={() => { removeSerie(index) }}>
                                  <i className="ph ph-minus" />
                                </div>
                            }
                          </div>
                 })
               }
             </div>
             <div className="btn btn-primary btn-circle" onClick={ addSerie }>
               <i className="ph ph-plus" />
             </div>
           </div>
           <DodoneFinishButton params = {{ log: { series: series } }} />
         </>;
}

const FinishedRecordableProgression = ({ dodone }) => {
  return <>
           <DodoneNextLink currentDodoneId = { dodone.id } />
         </>;
}

export default () => {
  const { setText } = useContext(HeaderContext);
  const { dodone } = useContext(DodoneContext);

  useEffect(() => {
    setText(dodone.dodoable.name)
  }, [dodone.id]);

  if(dodone.isFinished)
    return <FinishedRecordableProgression dodone={ dodone } />

  if(dodone.isStarted)
    return <StartedRecordableProgression />

  return <>
           <div className="flex-1"></div>
           <DodoneStartButton text="Start" />
         </>
};
